// extracted by mini-css-extract-plugin
module.exports = {"aboutMeContainer":"aboutme-module--aboutMeContainer--qvrWC","aboutMeHeading":"aboutme-module--aboutMeHeading--37B0k","aboutMeContent":"aboutme-module--aboutMeContent--3sCrG"};